// Angular imports
import { Component } from '@angular/core';

// CC-Common imports
import { CCLocalStorageService } from 'cc-common';

// Component imports
import { MPBaseDashboardWidgetComponent } from '../../../_base/mp-base-dashboard-widget.component';

// Service imports
import { ContextManagerService } from '../../../_services/data-services/context-manager.service';
import { WidgetContextFactoryService } from '../../../_services/data-services/widget-context-factory.service';
import { SharedWidgetsService } from '../../_services/shared-widgets.service';

// Model imports
import { PropertyCommunityInfoResultDto } from '../../../_models/property-community-info-result-dto';
import { ConveyanceResultDto } from '../../_models/conveyance-result-dto';

@Component({
    selector: 'app-conveyance-widget',
    templateUrl: './conveyance-widget.component.html',
    styleUrls: ['./conveyance-widget.component.scss']
})
export class ConveyanceWidgetComponent extends MPBaseDashboardWidgetComponent {
    minWidthRatio = 50;
    conveyanceData: ConveyanceResultDto[];

    constructor(
        protected readonly contextService: ContextManagerService,
        protected readonly widgetContextFactory: WidgetContextFactoryService,
        protected readonly localStorageService: CCLocalStorageService,
        private readonly widgetService: SharedWidgetsService
    ) {
        super(contextService, widgetContextFactory, localStorageService);
    }

    // Override
    refresh(width: number, height: number): void {
        super.refresh(width, height - 20);
    }

    populateDashboardData(context: PropertyCommunityInfoResultDto): void {
        const communityId: number = !!context ? context.communityId : null;
        this.conveyanceData = null;
        this.loadingCompleted = false;
        this.widgetService.getConveyanceActivity(communityId).subscribe((results) => {
            this.conveyanceData = results;
            this.loadingCompleted = true;
        });
    }
}
